export const FeatureRequest = {
  question: "How do I request a feature or provide feedback?",
  answer: `
Feature requests and product feedback are welcome, but that doesn't mean everything will be implemented. Please submit your feedback in the [Firestation portal](https://firehydrant.atlassian.net/servicedesk/customer/portal/2/group/9/create/70) and not via Slack message. Your feedback is valuable but if submitted in Slack it will unfornately disappear into a blackhole.
`
}